import { render, staticRenderFns } from "./ListTodoAssignedToMe.vue?vue&type=template&id=3c264aba&"
import script from "./ListTodoAssignedToMe.vue?vue&type=script&lang=js&"
export * from "./ListTodoAssignedToMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports